/**
 * 工作流书架栅格：与 {@link comicBookshelfGridClass} 同策略，列宽略大以容纳横版流程卡片。
 */
export const workflowShelfGridClass = [
  'grid w-full min-w-0 content-start items-start',
  'grid-cols-[repeat(auto-fill,minmax(min(100%,15rem),1fr))]',
  'gap-3 sm:gap-3.5 lg:gap-4',
  'md:grid-cols-[repeat(auto-fill,minmax(min(100%,16rem),1fr))]',
  'lg:grid-cols-[repeat(auto-fill,minmax(min(100%,17rem),1fr))]',
  'xl:grid-cols-[repeat(auto-fill,minmax(min(100%,18rem),1fr))]',
].join(' ')
